/**
 * OTA 升级 - 版本检查 + 安卓下载安装.
 */
import {Capacitor} from '@capacitor/core'
import {checkVersion} from '@/api/version'
import {showNotify, updateProgress, visible} from '@/stores/notify'

export const APP_VERSION = '1.0.2'


export interface UpdateCheckResult {
    has_update: boolean
    latest_version: string
    current_version: string
    platform: string
}


interface NativeDownloaderResult {
    status: string
    filename: string
    savedTo: string
}

interface NativeDownloaderPlugin {
    download: (opts: { url: string; filename: string }) => Promise<NativeDownloaderResult>
    installApk: (opts: { savedTo: string }) => Promise<void>
    exitApp: () => Promise<void>
    addListener: (eventName: string, listener: (data: { progress: number }) => void) => Promise<{ remove: () => Promise<void> }>
}

function getDownloader(): NativeDownloaderPlugin {
    const plugins = (Capacitor as unknown as { Plugins: Record<string, NativeDownloaderPlugin> }).Plugins
    const downloader = plugins['NativeDownloader']
    if (!downloader) throw new Error('NativeDownloader plugin not found')
    return downloader
}

export async function checkAndDownloadUpdate(): Promise<void> {
    try {
        const platform = Capacitor.getPlatform()
        if (platform !== 'android') return
        const result = await checkVersion('android', APP_VERSION)
        if (!result.has_update) return

        showNotify({
            title: `发现新版本 v${result.latest_version}`,
            message: result.description || `v${result.latest_version} 已发布`,
            confirmText: '立即更新',
            dismissible: !result.force_update,
            onConfirm: async () => {
                showNotify({
                    title: '正在下载更新',
                    message: `v${result.latest_version} 下载中，请稍候`,
                    confirmText: '',
                    dismissible: false,
                    onConfirm: () => {
                    },
                })
                updateProgress(0.1)
                try {
                    const downloader = getDownloader()
                    const listener = await downloader.addListener('downloadProgress', (data) => {
                        updateProgress(data.progress)
                    })
                    const dl = await downloader.download({
                        url: result.download_url,
                        filename: `zhixing-ai-v${result.latest_version}.apk`,
                    })
                    console.log('[OTA] download result', JSON.stringify(dl))
                    await listener.remove()
                    updateProgress(100)
                    visible.value = false
                    await new Promise(r => setTimeout(r, 1000))
                    console.log('[OTA] calling installApk', dl.savedTo)
                    try {
                        await downloader.installApk({savedTo: dl.savedTo})
                    } catch (installErr) {
                        console.error('[OTA] installApk failed', installErr)
                    }
                } catch (e) {
                    console.error('[OTA] download/install failed', e)
                }
            },
        })
    } catch (e) {
        console.error('[OTA] check update failed', e)
    }
}
